export const Syntax = {
  ArrayExpression: 'ArrayExpression' as 'ArrayExpression',
  ArrayPattern: 'ArrayPattern' as 'ArrayPattern',
  ArrowFunctionExpression: 'ArrowFunctionExpression' as 'ArrowFunctionExpression',
  AssignmentExpression: 'AssignmentExpression' as 'AssignmentExpression',
  AssignmentPattern: 'AssignmentPattern' as 'AssignmentPattern',
  AwaitExpression: 'AwaitExpression' as 'AwaitExpression',
  BinaryExpression: 'BinaryExpression' as 'BinaryExpression',
  BlockStatement: 'BlockStatement' as 'BlockStatement',
  BreakStatement: 'BreakStatement' as 'BreakStatement',
  CallExpression: 'CallExpression' as 'CallExpression',
  CatchClause: 'CatchClause' as 'CatchClause',
  ClassBody: 'ClassBody' as 'ClassBody',
  ClassDeclaration: 'ClassDeclaration' as 'ClassDeclaration',
  ClassExpression: 'ClassExpression' as 'ClassExpression',
  ConditionalExpression: 'ConditionalExpression' as 'ConditionalExpression',
  ContinueStatement: 'ContinueStatement' as 'ContinueStatement',
  DebuggerStatement: 'DebuggerStatement' as 'DebuggerStatement',
  DoWhileStatement: 'DoWhileStatement' as 'DoWhileStatement',
  EmptyStatement: 'EmptyStatement' as 'EmptyStatement',
  ExportAllDeclaration: 'ExportAllDeclaration' as 'ExportAllDeclaration',
  ExportDefaultDeclaration: 'ExportDefaultDeclaration' as 'ExportDefaultDeclaration',
  ExportNamedDeclaration: 'ExportNamedDeclaration' as 'ExportNamedDeclaration',
  ExportSpecifier: 'ExportSpecifier' as 'ExportSpecifier',
  ExpressionStatement: 'ExpressionStatement' as 'ExpressionStatement',
  ForInStatement: 'ForInStatement' as 'ForInStatement',
  ForOfStatement: 'ForOfStatement' as 'ForOfStatement',
  ForStatement: 'ForStatement' as 'ForStatement',
  FunctionDeclaration: 'FunctionDeclaration' as 'FunctionDeclaration',
  FunctionExpression: 'FunctionExpression' as 'FunctionExpression',
  Identifier: 'Identifier' as 'Identifier',
  IfStatement: 'IfStatement' as 'IfStatement',
  Import: 'Import' as 'Import',
  ImportDeclaration: 'ImportDeclaration' as 'ImportDeclaration',
  ImportDefaultSpecifier: 'ImportDefaultSpecifier' as 'ImportDefaultSpecifier',
  ImportNamespaceSpecifier: 'ImportNamespaceSpecifier' as 'ImportNamespaceSpecifier',
  ImportSpecifier: 'ImportSpecifier' as 'ImportSpecifier',
  LabeledStatement: 'LabeledStatement' as 'LabeledStatement',
  Literal: 'Literal' as 'Literal',
  LogicalExpression: 'LogicalExpression' as 'LogicalExpression',
  MemberExpression: 'MemberExpression' as 'MemberExpression',
  MetaProperty: 'MetaProperty' as 'MetaProperty',
  MethodDefinition: 'MethodDefinition' as 'MethodDefinition',
  NewExpression: 'NewExpression' as 'NewExpression',
  ObjectExpression: 'ObjectExpression' as 'ObjectExpression',
  ObjectPattern: 'ObjectPattern' as 'ObjectPattern',
  Program: 'Program' as 'Program',
  Property: 'Property' as 'Property',
  RestElement: 'RestElement' as 'RestElement',
  ReturnStatement: 'ReturnStatement' as 'ReturnStatement',
  SequenceExpression: 'SequenceExpression' as 'SequenceExpression',
  SpreadElement: 'SpreadElement' as 'SpreadElement',
  Super: 'Super' as 'Super',
  SwitchCase: 'SwitchCase' as 'SwitchCase',
  SwitchStatement: 'SwitchStatement' as 'SwitchStatement',
  TaggedTemplateExpression: 'TaggedTemplateExpression' as 'TaggedTemplateExpression',
  TemplateElement: 'TemplateElement' as 'TemplateElement',
  TemplateLiteral: 'TemplateLiteral' as 'TemplateLiteral',
  ThisExpression: 'ThisExpression' as 'ThisExpression',
  ThrowStatement: 'ThrowStatement' as 'ThrowStatement',
  TryStatement: 'TryStatement' as 'TryStatement',
  UnaryExpression: 'UnaryExpression' as 'UnaryExpression',
  UpdateExpression: 'UpdateExpression' as 'UpdateExpression',
  VariableDeclaration: 'VariableDeclaration' as 'VariableDeclaration',
  VariableDeclarator: 'VariableDeclarator' as 'VariableDeclarator',
  WhileStatement: 'WhileStatement' as 'WhileStatement',
  WithStatement: 'WithStatement' as 'WithStatement',
  YieldExpression: 'YieldExpression' as 'YieldExpression',
  JSXElement: 'JSXElement' as 'JSXElement',
  ExportNamespaceSpecifier: 'ExportNamespaceSpecifier' as 'ExportNamespaceSpecifier',
};
